import { Button, Text } from "@ucl/react-library";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { updateCustomerDetails } from "src/api/services/customer-service";
import { useCase } from "src/context/case-context";
import { ConfirmModal } from "../confirm-modal/confirm-modal";
import { Loader } from "src/utils/loader";

import { RedressParticipation } from "src/api/types/enums";

export const OptOut = () => {
  const { t } = useTranslation("translation", { keyPrefix: "optOut" });
  const navigate = useNavigate();
  const { customerData, setCustomerData } = useCase();
  const [showModal, setShowModal] = useState(false);
  const [showError, setShowError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!customerData) {
    return null;
  }

  const submitLeaveScheme = async () => {
    try {
      const data = {
        redress: {
          redressParticipation: RedressParticipation.OPTED_OUT,
        },
      };

      setIsSubmitting(true);
      setShowModal(false);
      const updatedData = await updateCustomerDetails(data);
      setCustomerData(updatedData);

      navigate("/thank-you", {
        state: { pageType: "optedOut" },
      });
    } catch {
      setShowModal(true);
      setShowError(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleConfirm = () => {
    setShowError(false);
    submitLeaveScheme();
  };

  const handleCancel = () => {
    setShowModal(false);
    setShowError(false);
  };

  return (
    <>
      <div className="flex flex-col items-start gap-5" data-testid="optOutComponent">
        <Text renderAs="h3" styleType="h4" fontWeight="semi-bold">{t("title")}</Text>
        <Text.P size="large">{t("para")}</Text.P>
        <Button className={"w-full sm:w-fit self-start"} variant="secondary" onClick={() => setShowModal(true)} >{t("optOutScheme")}</Button>
        <ConfirmModal isOpen={showModal} handleSubmit={handleConfirm} handleCancel={handleCancel} translationKey="confirmLeaveSchemeModal" showError={showError} />
      </div>
      {isSubmitting && <Loader />}
    </>

  );
};